
<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-col md="12" sm="12" class="pa-0 ma-0">
      <v-tabs v-model="nTabSelect" align-with-title dark active-class="active-item" background-color="#161E33" class="mt-1" height="36px">
        <v-tabs-slider color="btndest lighten-3"></v-tabs-slider>
        <v-tab v-for="nameTab in aInfoTab" :key="nameTab" dark>
          {{nameTab}} 
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="nTabSelect">
        <v-tab-item>
          <grid ref="GridPrincipal"
              v-if="this.$store.state.token!=''"
              :key="nRefresGrid"
              :tabla="aTablaName"
              :bActiveFilter="true"
              :bActiveExport="false"
              :bSingleSelect="false"
              :bShowSelect="false"
              :sIdTable="aIdTable"
              :bShowMapDetails="false"
              :bActiveNew="false"
              :cabeceraVisible="false"
              altoTabla="48vh">
            </grid>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid :key="nRefresGridFeriados">
            <v-row class="no-gutters my-2" >
              <v-col cols="12" sm="8" class="d-flex justify-start align-center">
                <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                  {{$store.state.jsIdioma.oEquivalencias.btnHoy}}
                </v-btn>
                <v-btn dense fab small color="primary" @click="prev">
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar" class="mx-3">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-btn dense fab small color="primary" @click="next">
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" class="text-center pa-1">
                <v-btn color="primary" small @click="onCargarMasivo" rounded>
                  <v-icon left>mdi-plus-circle-outline</v-icon>
                  {{ $store.state.jsIdioma.oEquivalencias.btnCargarInforamacion}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-row class="no-gutters my-1">
            <v-col cols="12">
              <v-calendar
                :value="sFechaCalendario"
                v-model="focus"
                :events="aEventos"
                color="primary"
                type="month"
                ref="calendar"
                locale="es"
                @click:date="viewDay"
              >
                <!-- @change="updateRange" -->
                <template v-slot:day="{date}">
                  <v-row class="no-gutters fill-height">
                    <v-col cols="12" class="text-center ma-0 pa-1">
                        <v-btn icon small color="primary" @click="onCargarDia(date)"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                        <span>{{$store.state.jsIdioma.oEquivalencias.btnAgregar}}</span>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:event="{ event }">
                  <v-row class="no-gutters fill-height">
                    <v-col @click="onElimianrDia(event)" cols="12" class="text-center ma-0 pa-0">
                    {{event.name}}
                    <div></div>
                    </v-col>
                  </v-row>
                </template>
              </v-calendar>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
    <FormAgregarMasivoFestivo
    v-if="bVerCargarMasivo"
    v-model="bVerCargarMasivo"
    @guardado="onGuardar"
    />
    <FormAgregarDiaFestivo
    v-model="bVerCargarDia"
    :sDia="sDiaSelect"
    @guardado="onGuardar"
    />
  </v-container>  

</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import FormAgregarMasivoFestivo from '@/components/Seif/pqr/FormAgregarMasivoFestivo.vue'
import FormAgregarDiaFestivo  from '@/components/Seif/pqr/FormAgregarDiaFestivo.vue'
import axiosServices from '@/services/axiosServices.js'
import fManejadorFecha from "@/Utlidades/Hora_Fecha.js"

export default {
  name:"ConfigParameetrizacinDias",
  components: {
    grid,
    FormAgregarMasivoFestivo,
    FormAgregarDiaFestivo
  },
  data() {
    return {
      aInfoTab   : ['Días hábiles', 'Días festivos'],
      bVerCargarMasivo: false,
      bVerCargarDia: false,
      sDiaSelect:'',
      aEventos: [],
      nTabSelect : 0,
      aTablaName  : 'Dias_Semanas',
      aIdTable    : 'idDia',
      nRefresGrid : 0,
      nRefresGridFeriados: 0,
      sFechaCalendario: fManejadorFecha.getDia(),
      focus: '',
    }
  },
  mounted () {
    this.onCargarInfo()
  },
  methods: {
    onGuardar () {
      this.onCargarInfo()
    },
    async onCargarInfo() {
      const aResponse2 = await axiosServices.getConfiguration('pqr/festivos', true);
        if(aResponse2.nStatusCode === 200) {
          this.aEventos= []
          aResponse2.aData.forEach(oItem =>  {
            this.aEventos.push({
              name: 'Festivo',
              color: '#6E85B7',
              start: oItem.feriado,
              end: oItem.feriado,
              timed: true,
            })
          })

        }
    },
    async onElimianrDia(oItem) {
      this.$swal.fire({
          title: 'Eliminar Festivo',
          text: `¿Desea eliminar la fecha ${oItem.end} como festivo?`,
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.onBorrarFestivo(oItem.end)
          }
        })
    },
    async onBorrarFestivo (sFecha) {
      const oRespuesta = await axiosServices.deleteConfiguration('pqr/festivo/' + sFecha, {}, true)
      oRespuesta
      this.onCargarInfo()
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    onCargarMasivo(){
      this.bVerCargarMasivo = true
    },
    onCargarDia(dia){
      this.bVerCargarDia = true
      this.sDiaSelect = dia
    },
    setToday () {
      this.focus = ''
    },
    viewDay ({ date }) {
      //console.log(date)
      this.focus = date
    },
  },
  watch: {
    nTabSelect(){
      this.nRefresGrid++
    }
  },
}
</script>

<style lang="scss" scoped>

.avatar-num-span{
  font-size: 10px;
}
</style>